window.$ = window.jQuery = require('jquery');
require('vgnav/dist/js/vgnav');
require('vgformsender/dist/js/vegasformsender.min');
require('vgscrollto/dist/js/vegascrollto.min');
require('popper.js/dist/popper.min');
require('bootstrap/dist/js/bootstrap.min');
require('owl.carousel/dist/owl.carousel.min');
require('jquery-nice-select/js/jquery.nice-select.min');
require('@fancyapps/fancybox/dist/jquery.fancybox');
require('inputmask/dist/inputmask.min');
require('ion-rangeslider/js/ion.rangeSlider.min');

require('../../vendor/vegas/sidebar/jquery.vegasSidebar');
require('./modules/store/cart');
require('./modules/store/catalog');
require('./modules/bg');
require('./modules/catalogNavButton');
require('./modules/owl');
require('./modules/modal');
require('./modules/search');
require('./modules/vegas');
require('./modules/ym');
require('./functions');

// [[vegas]]
require('./custom');
